'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('./base/index.less');
var Accordion = _interopDefault(require('./accordion'));
var ActionSheet = _interopDefault(require('./action-sheet'));
var Agreement = _interopDefault(require('./agreement'));
var Background = _interopDefault(require('./background'));
var Badge = _interopDefault(require('./badge'));
var BankcardSheet = _interopDefault(require('./bankcard-sheet'));
var Banner = _interopDefault(require('./banner'));
var Bill = _interopDefault(require('./bill'));
var BillDetail = _interopDefault(require('./bill-detail'));
var BottomLink = _interopDefault(require('./bottom-link'));
var Bounce = _interopDefault(require('./bounce'));
var Box = _interopDefault(require('./box'));
var Bulletin = _interopDefault(require('./bulletin'));
var Button = _interopDefault(require('./button'));
var ButtonGroup = _interopDefault(require('./button-group'));
var ButtonJustify = _interopDefault(require('./button-justify'));
var ButtonLine = _interopDefault(require('./button-line'));
var Cell = _interopDefault(require('./cell'));
var CellInfo = _interopDefault(require('./cell-info'));
var CellLeft = _interopDefault(require('./cell-left'));
var CellRight = _interopDefault(require('./cell-right'));
var Checkbox = _interopDefault(require('./checkbox'));
var CollapseTransition = _interopDefault(require('./collapse-transition'));
var CountUp = _interopDefault(require('./count-up'));
var CustomInput = _interopDefault(require('./custom-input'));
var DatePicker = _interopDefault(require('./date-picker'));
var Directive = _interopDefault(require('./directive'));
var Form = _interopDefault(require('./form'));
var Help = _interopDefault(require('./help'));
var HelpDetail = _interopDefault(require('./help-detail'));
var IconLoading = _interopDefault(require('./icon-loading'));
var IconRing = _interopDefault(require('./icon-ring'));
var IconSpin = _interopDefault(require('./icon-spin'));
var IndexSidebar = _interopDefault(require('./index-sidebar'));
var Keyboard = _interopDefault(require('./keyboard'));
var lazyload = _interopDefault(require('./lazyload'));
var modal = _interopDefault(require('./modal'));
var MonthPicker = _interopDefault(require('./month-picker'));
var Nav = _interopDefault(require('./nav'));
var NavOptions = _interopDefault(require('./nav-options'));
var Password = _interopDefault(require('./password'));
var Picker = _interopDefault(require('./picker'));
var Progress = _interopDefault(require('./progress'));
var ProgressRing = _interopDefault(require('./progress-ring'));
var PullRefresh = _interopDefault(require('./pull-refresh'));
var ScrollView = _interopDefault(require('./scroll-view'));
var Selector = _interopDefault(require('./selector'));
var SmsButton = _interopDefault(require('./sms-button'));
var Stepper = _interopDefault(require('./stepper'));
var SuspendMenu = _interopDefault(require('./suspend-menu'));
var SwipeCell = _interopDefault(require('./swipe-cell'));
var SwipeOut = _interopDefault(require('./swipe-out'));
var Tab = _interopDefault(require('./tab'));
var Tap = _interopDefault(require('./tap'));
var toast = _interopDefault(require('./toast'));
var Toggle = _interopDefault(require('./toggle'));
var validator = _interopDefault(require('./validator'));

// This file is generated by npm run build:entry
var components = [Accordion, ActionSheet, Agreement, Background, Badge, BankcardSheet, Banner, Bill, BillDetail, BottomLink, Bounce, Box, Bulletin, Button, ButtonGroup, ButtonJustify, ButtonLine, Cell, CellInfo, CellLeft, CellRight, Checkbox, CollapseTransition, CountUp, CustomInput, DatePicker, Directive, Form, Help, HelpDetail, IconLoading, IconRing, IconSpin, IndexSidebar, Keyboard, MonthPicker, Nav, NavOptions, Password, Picker, Progress, ProgressRing, PullRefresh, ScrollView, Selector, SmsButton, Stepper, SuspendMenu, SwipeCell, SwipeOut, Tab, Toggle];
function install(Vue) {
  components.map(function (component) {
    return Vue.use(component);
  });
  Vue.use(Tap);
  Vue.prototype.$toast = toast;
  Vue.prototype.$modal = modal;
  Vue.prototype.$validator = validator;
}

exports.Accordion = Accordion;
exports.ActionSheet = ActionSheet;
exports.Agreement = Agreement;
exports.Background = Background;
exports.Badge = Badge;
exports.BankcardSheet = BankcardSheet;
exports.Banner = Banner;
exports.Bill = Bill;
exports.BillDetail = BillDetail;
exports.BottomLink = BottomLink;
exports.Bounce = Bounce;
exports.Box = Box;
exports.Bulletin = Bulletin;
exports.Button = Button;
exports.ButtonGroup = ButtonGroup;
exports.ButtonJustify = ButtonJustify;
exports.ButtonLine = ButtonLine;
exports.Cell = Cell;
exports.CellInfo = CellInfo;
exports.CellLeft = CellLeft;
exports.CellRight = CellRight;
exports.Checkbox = Checkbox;
exports.CollapseTransition = CollapseTransition;
exports.CountUp = CountUp;
exports.CustomInput = CustomInput;
exports.DatePicker = DatePicker;
exports.Directive = Directive;
exports.Form = Form;
exports.Help = Help;
exports.HelpDetail = HelpDetail;
exports.IconLoading = IconLoading;
exports.IconRing = IconRing;
exports.IconSpin = IconSpin;
exports.IndexSidebar = IndexSidebar;
exports.Keyboard = Keyboard;
exports.Lazyload = lazyload;
exports.modal = modal;
exports.MonthPicker = MonthPicker;
exports.Nav = Nav;
exports.NavOptions = NavOptions;
exports.Password = Password;
exports.Picker = Picker;
exports.Progress = Progress;
exports.ProgressRing = ProgressRing;
exports.PullRefresh = PullRefresh;
exports.ScrollView = ScrollView;
exports.Selector = Selector;
exports.SmsButton = SmsButton;
exports.Stepper = Stepper;
exports.SuspendMenu = SuspendMenu;
exports.SwipeCell = SwipeCell;
exports.SwipeOut = SwipeOut;
exports.Tab = Tab;
exports.Tap = Tap;
exports.toast = toast;
exports.Toggle = Toggle;
exports.validator = validator;
exports.default = install;
